import { ResultType } from "@shared/clients/api.generated";

export enum MapAreaStyle {
    FinalResult = 'geography_final_result',
    PartialResult = 'geography_partial_result',
    PreliminaryResult = 'geography_preliminary_result',
    NoResults = 'geography_no_results',
    NoData = 'nodata'
}

export interface MapAreaData {
  style: MapAreaStyle,
  id: string,
  displayName: string,
}

export interface MapAreasMapping { [key: string]: MapAreaData }

const MapAreaStyleMapping = {
  [ResultType.FinalResult]: MapAreaStyle.FinalResult,
  [ResultType.PartialResult]: MapAreaStyle.PartialResult,
  [ResultType.PreliminaryResult]: MapAreaStyle.PreliminaryResult,
  [ResultType.NoResults]: MapAreaStyle.NoResults
}

export function getMapAreaStyle(resultType: ResultType) {
  return MapAreaStyleMapping[resultType];
}
